import { render } from "./PostIndex.vue?vue&type=template&id=e00981a0&scoped=true"
import script from "./PostIndex.vue?vue&type=script&lang=js"
export * from "./PostIndex.vue?vue&type=script&lang=js"

import "./PostIndex.vue?vue&type=style&index=0&id=e00981a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00981a0"]])

export default __exports__